import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.promise";
import "regenerator-runtime/runtime";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import { get, cloneDeep, set } from 'lodash';
import codemirror from '@/mixins/codemirror';
import iconsMixin from '../../components/core/dtwin/state/bridge/iconsMixin';
import multiSearchMixin from '@/mixins/multiSearchVirtualDevices';
import { versionsHasUnsyncedChanges, getUnsyncedChanges } from '../../utils/deviceTemplateUtils';
export default {
  name: 'DeviceTemplatesDetails',
  mixins: [iconsMixin, multiSearchMixin, codemirror],
  data: function data() {
    return {
      accounts: [],
      account: null,
      parentTree: null,
      isDeviceMetaFormValid: true,
      isTemplateMetaFormValid: true,
      isDataStatesFormValid: true,
      useExpertMode: false,
      templateInformation: {
        templateIsChanged: false,
        isProductiveVersion: false,
        templateHasProductiveVersion: false,
        hasUnsyncedChanges: false,
        linkedDevicesTotalCount: -1,
        unsyncedChanges: []
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])), {}, {
    itemId: function itemId() {
      return this.$route.params.id;
    },
    availableDurations: function availableDurations() {
      var _this = this;

      var baseTranslation = 'DigitalTwin.DigitalTwin.visualization.timeRanges.count';
      return [15, 30].map(function (min) {
        return {
          value: min * 60,
          label: _this.$i18n_tc("".concat(baseTranslation, "Min"), min, {
            n: min
          })
        };
      }).concat([1, 3, 6, 12, 24].map(function (hour) {
        return {
          value: hour * 3600,
          label: _this.$i18n_tc("".concat(baseTranslation, "Hour"), hour, {
            n: hour
          })
        };
      })).concat([2, 7, 14].map(function (day) {
        return {
          value: day * 86400,
          label: _this.$i18n_tc("".concat(baseTranslation, "Day"), day, {
            n: day
          })
        };
      })).concat([1, 3, 6].map(function (mon) {
        return {
          value: mon * 30 * 86400,
          label: _this.$i18n_tc("".concat(baseTranslation, "Month"), mon, {
            n: mon
          })
        };
      })).concat([{
        value: 365 * 86400,
        label: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.timeRanges.1Y')
      }]);
    },
    deviceMetaInformationTab: function deviceMetaInformationTab() {
      return {
        label: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.deviceMetaInformation'),
        urlHashbang: 'tab-device-meta',
        rows: [{
          columns: [{
            cols: 12,
            sm: 12,
            md: 12,
            lg: 12,
            slotName: 'deviceMetaInformation'
          }]
        }]
      };
    },
    templateMetaInformationTab: function templateMetaInformationTab() {
      return {
        label: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.templateMetaInformation'),
        urlHashbang: 'tab-template-meta',
        rows: [{
          columns: [{
            cols: 12,
            sm: 12,
            md: 12,
            lg: 12,
            slotName: 'templateMetaInformation'
          }]
        }]
      };
    },
    dataStatesTab: function dataStatesTab() {
      return {
        label: this.$i18n_t('DigitalTwin.DigitalTwin.dataStates'),
        urlHashbang: 'tab-data-states',
        rows: [{
          columns: [{
            cols: 12,
            sm: 12,
            md: 12,
            lg: 12,
            slotName: 'dataStates'
          }]
        }]
      };
    },
    ruleEditorTab: function ruleEditorTab() {
      return {
        label: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.ruleEditor'),
        urlHashbang: 'tab-rule-editor',
        rows: [{
          columns: [{
            cols: 12,
            sm: 12,
            md: 12,
            lg: 12,
            slotName: 'ruleEditor'
          }]
        }]
      };
    },
    linkedDevicesTab: function linkedDevicesTab() {
      return {
        label: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.relatedDevices', {
          count: this.templateInformation.linkedDevicesTotalCount
        }),
        urlHashbang: 'linked-devices',
        eager: true,
        rows: [{
          columns: [{
            cols: 12,
            sm: 12,
            md: 12,
            lg: 12,
            slotName: 'linkedDevices'
          }]
        }]
      };
    },
    unsyncedChangesTab: function unsyncedChangesTab() {
      return {
        label: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.unsyncedChanges'),
        urlHashbang: 'tab-unsynced-changes',
        rows: [{
          columns: [{
            cols: 12,
            sm: 12,
            md: 12,
            lg: 12,
            slotName: 'unsyncedChanges'
          }]
        }]
      };
    },
    tabs: function tabs() {
      return [this.templateMetaInformationTab, this.deviceMetaInformationTab, this.dataStatesTab, this.ruleEditorTab, this.healthConfigurationTab, this.linkedDevicesTab, this.unsyncedChangesTab];
    },
    formValidCompute: function formValidCompute() {
      return this.isDeviceMetaFormValid && this.isTemplateMetaFormValid;
    },
    linkedDevicesPredefinedSearch: function linkedDevicesPredefinedSearch() {
      return [{
        param: 'deviceTemplateId',
        search: {
          value: this.itemId
        }
      }];
    }
  }),
  created: function () {
    var _created = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.fetchAccounts();
              _context.next = 3;
              return ApiService.deviceTemplateHasProductiveVersion(this.itemId);

            case 3:
              this.templateInformation.templateHasProductiveVersion = _context.sent;

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function mounted() {},
  methods: {
    get: get,
    fetchItem: function () {
      var _fetchItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params) {
        var item, metrics;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                item = null;

                if (!(params && params.productiveVersion)) {
                  _context2.next = 9;
                  break;
                }

                this.templateInformation.isProductiveVersion = true;
                _context2.next = 6;
                return ApiService.deviceTemplateGetByIdProductive(this.itemId);

              case 6:
                item = _context2.sent;
                _context2.next = 13;
                break;

              case 9:
                this.templateInformation.isProductiveVersion = false;
                _context2.next = 12;
                return ApiService.deviceTemplateGetByIdDraft(this.itemId);

              case 12:
                item = _context2.sent;

              case 13:
                this.templateInformation.hasUnsyncedChanges = versionsHasUnsyncedChanges(item);
                this.templateInformation.unsyncedChanges = getUnsyncedChanges(item);

                if (!item.deviceMeta.connectorData) {
                  item.deviceMeta.connectorData = {};
                }

                _context2.prev = 16;
                _context2.next = 19;
                return this.buildDtwinTree(item);

              case 19:
                _context2.next = 25;
                break;

              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2["catch"](16);

                if (_context2.t0.response && this.$i18n_t("Error.".concat(_context2.t0.response.data.message))) {
                  this.$snack(this.$i18n_t("Error.".concat(_context2.t0.response.data.message)), 'error');
                } else {
                  this.$snack(this.$i18n_t('Common.digitalTwins.twinNotFound'), 'error');
                }

                this.$router.push({
                  path: '/device-templates'
                });

              case 25:
                metrics = get(item, 'healthDefinition.health', []);

                if (metrics.length > 0) {
                  this.useExpertMode = !metrics.some(function (m) {
                    return m.wizard;
                  });
                }

                return _context2.abrupt("return", item);

              case 30:
                _context2.prev = 30;
                _context2.t1 = _context2["catch"](0);
                console.error('Error fetching item:', _context2.t1);

              case 33:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 30], [16, 21]]);
      }));

      function fetchItem(_x) {
        return _fetchItem.apply(this, arguments);
      }

      return fetchItem;
    }(),
    updateUnsavedChanges: function updateUnsavedChanges(template) {
      this.templateInformation.unsyncedChanges = getUnsyncedChanges(template);
    },
    headline: function headline(item) {
      if (!item) {
        return;
      }

      return item.title || this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.deviceTemplate');
    },
    subtitle: function subtitle(item) {
      if (!item) {
        return;
      }

      return item.account || this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.editInformation');
    },
    saveItem: function () {
      var _saveItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(item) {
        var _this2 = this;

        var healthBaseKey, metrics, template;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                healthBaseKey = 'healthDefinition.health';
                metrics = get(item, "".concat(healthBaseKey), []);
                set(item, healthBaseKey, metrics.map(function (m) {
                  return _objectSpread(_objectSpread({}, m), {}, {
                    wizard: !_this2.useExpertMode
                  });
                }));
                _context3.prev = 3;
                _context3.next = 6;
                return ApiService.deviceTemplateUpdate(item);

              case 6:
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](3);
                this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.snacks.updateError'), 'error');

              case 11:
                _context3.next = 13;
                return ApiService.deviceTemplateGetByIdDraft(item.id);

              case 13:
                template = _context3.sent;
                this.templateInformation.hasUnsyncedChanges = versionsHasUnsyncedChanges(template);
                this.templateInformation.unsyncedChanges = getUnsyncedChanges(template);
                return _context3.abrupt("return", template);

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 8]]);
      }));

      function saveItem(_x2) {
        return _saveItem.apply(this, arguments);
      }

      return saveItem;
    }(),
    fetchAccounts: function () {
      var _fetchAccounts = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var accounts;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.$store.dispatch('app/loadAccounts');

              case 3:
                accounts = _context4.sent;
                this.accounts = accounts.filter(function (t) {
                  return !t.isRootTenant;
                });
                _context4.next = 11;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);
                console.error(_context4.t0);
                this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.failedToFetchAccounts'), 'error');

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7]]);
      }));

      function fetchAccounts() {
        return _fetchAccounts.apply(this, arguments);
      }

      return fetchAccounts;
    }(),
    ancestorList: function ancestorList() {
      var extract = function extract(tree) {
        if (tree.children && tree.children.length > 0) {
          return [tree].concat(extract(tree.children[0]));
        }

        return [tree];
      };

      if (this.parentTree) {
        return cloneDeep(extract(this.parentTree).filter(function (i) {
          return i && i.id;
        }).concat([this.template]));
      }

      return [];
    },
    buildDtwinTree: function () {
      var _buildDtwinTree = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(item) {
        var _this3 = this;

        var parentPartialTreePromise, parentObjectPromise;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                parentPartialTreePromise = ApiService.digitalTwinFetchPartialTree(this, item.parentId, undefined, undefined, ['no-children']);
                parentObjectPromise = item.parentId ? ApiService.digitalTwinGet(this, item.parentId, true) : Promise.resolve({});
                return _context5.abrupt("return", parentPartialTreePromise.then(function (result) {
                  var tree = result;
                  _this3.parentTree = get(tree, 'digitaltwins[0]', {});

                  var ancestorList = _this3.ancestorList();

                  var accountTitle = get(ancestorList, '[0].tenantName', undefined);
                  var accountId = get(ancestorList, '[0].tenantId', undefined);

                  if (accountTitle && accountId) {
                    _this3.account = "".concat(accountTitle, " (ID: ").concat(accountId, ")");
                  }

                  return parentObjectPromise;
                }));

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function buildDtwinTree(_x3) {
        return _buildDtwinTree.apply(this, arguments);
      }

      return buildDtwinTree;
    }(),
    handleDeviceMetaFormValidated: function handleDeviceMetaFormValidated(isValid) {
      this.isDeviceMetaFormValid = isValid;
    },
    handleTemplateMetaFormValidated: function handleTemplateMetaFormValidated(isValid) {
      this.isTemplateMetaFormValid = isValid;
    },
    handleDataStatesFormValidated: function handleDataStatesFormValidated(isValid) {
      this.isDataStatesFormValid = isValid;
    },
    setLinkedDevicesTotalCountItems: function setLinkedDevicesTotalCountItems(payload) {
      this.templateInformation.linkedDevicesTotalCount = payload.totalCount;
    },
    updateUnsyncedChanges: function updateUnsyncedChanges(item) {
      this.templateInformation.hasUnsyncedChanges = versionsHasUnsyncedChanges(item);
      this.templateInformation.unsyncedChanges = getUnsyncedChanges(item);
    },
    healthConfigurationTab: function healthConfigurationTab(item, originalItem) {
      var _this4 = this;

      var metrics = get(item, 'healthDefinition.health', []);
      var healthBaseKey = 'healthDefinition';
      return {
        label: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.deviceHealthConfig'),
        urlHashbang: 'tab-health-configuration',
        rows: [{
          columns: [{
            field: {
              label: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.expertMode'),
              type: 'switch',
              value: this.useExpertMode,
              onInput: function () {
                var _onInput = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref) {
                  var updateItemByFieldKey, waitForUserConsent, rerenderInput, hasConsent;
                  return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          updateItemByFieldKey = _ref.updateItemByFieldKey, waitForUserConsent = _ref.waitForUserConsent, rerenderInput = _ref.rerenderInput;
                          _context6.next = 3;
                          return waitForUserConsent(_this4.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.swapExpertModeDialog.title'), _this4.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.swapExpertModeDialog.message'));

                        case 3:
                          hasConsent = _context6.sent;

                          if (hasConsent) {
                            _context6.next = 6;
                            break;
                          }

                          return _context6.abrupt("return");

                        case 6:
                          updateItemByFieldKey("".concat(healthBaseKey, ".health"), metrics.map(function (m) {
                            return _objectSpread(_objectSpread({}, m), {}, {
                              wizard: _this4.useExpertMode
                            });
                          }));
                          _this4.useExpertMode = !_this4.useExpertMode;
                          rerenderInput();

                        case 9:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6);
                }));

                function onInput(_x4) {
                  return _onInput.apply(this, arguments);
                }

                return onInput;
              }()
            }
          }]
        }].concat(_toConsumableArray(this.useExpertMode ? this.healthStateExpertTabRows(item, originalItem) : this.healthStateNormalTabRows(item, originalItem)))
      };
    },
    healthStateNormalTabRows: function healthStateNormalTabRows(item) {
      var _this5 = this;

      var healthBaseKey = 'healthDefinition.health';
      var currentHealthStates = get(item, healthBaseKey, []);

      var valueField = function valueField(state) {
        if (state.operator === 'VALUE_OLDER_THAN') {
          return {
            key: 'value',
            label: _this5.$i18n_t('DigitalTwin.VirtualDevice.state.health.olderThanDuration'),
            type: 'select',
            options: _this5.availableDurations,
            required: true
          };
        }

        return {
          key: 'value',
          label: _this5.$i18n_t('DigitalTwin.DigitalTwin.states.value'),
          required: true
        };
      }; // const activeVersion = this.getActiveVersion(item);


      var wiredStateField = function wiredStateField(state) {
        if (state.operator === 'VALUE_OLDER_THAN') {
          return {
            key: 'wiredState',
            label: _this5.$i18n_t('DigitalTwin.DigitalTwin.states.dataState'),
            type: 'text',
            readonly: true,
            value: '_raw'
          };
        }

        return {
          key: 'wiredState',
          label: _this5.$i18n_t('DigitalTwin.DigitalTwin.states.dataState'),
          type: 'select',
          options: get(item, 'stateDefinition', []).filter(function (state) {
            return state.key !== '_health' && state.key !== '_parsed';
          }).map(function (state) {
            return {
              label: state.key,
              value: state.key
            };
          })
        };
      };

      var inputRows = [[{
        field: {
          key: 'type',
          label: this.$i18n_t('Common.type'),
          type: 'select',
          options: [{
            value: 'warning',
            label: this.$i18n_t('DigitalTwin.VirtualDevice.state.health.typeWarning')
          }, {
            value: 'error',
            label: this.$i18n_t('DigitalTwin.VirtualDevice.state.health.typeError')
          }]
        }
      }, {
        field: {
          key: 'category',
          label: this.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.label'),
          type: 'select',
          options: [{
            value: 'battery',
            label: this.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.value.battery')
          }, {
            value: 'connectivity',
            label: this.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.value.connectivity')
          }, {
            value: 'device',
            label: this.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.value.device')
          }]
        }
      }, {
        field: {
          key: 'description',
          label: this.$i18n_t('DigitalTwin.VirtualDevice.state.health.wizardDescriptionField')
        }
      }], [{
        field: wiredStateField
      }, {
        field: {
          type: 'select',
          key: 'operator',
          label: this.$i18n_t('Consumers.Filter.createDialog.operator'),
          options: [{
            label: this.$i18n_t('Consumers.Filter.createDialog.operators.valueOlderThan'),
            value: 'VALUE_OLDER_THAN'
          }, {
            label: this.$i18n_t('Consumers.Filter.createDialog.operators.equals'),
            value: 'EQUALS'
          }, {
            label: this.$i18n_t('Consumers.Filter.createDialog.operators.notEquals'),
            value: 'NOT_EQUALS'
          }, {
            label: this.$i18n_t('Consumers.Filter.createDialog.operators.greaterThan'),
            value: 'GREATER_THAN'
          }, {
            label: this.$i18n_t('Consumers.Filter.createDialog.operators.lessThan'),
            value: 'LESS_THAN'
          }, {
            label: this.$i18n_t('Consumers.Filter.createDialog.operators.contains'),
            value: 'CONTAINS'
          }, {
            label: this.$i18n_t('Consumers.Filter.createDialog.operators.notContains'),
            value: 'NOT_CONTAINS'
          }, {
            label: this.$i18n_t('Consumers.Filter.createDialog.operators.isNull'),
            value: 'IS_NULL'
          }, {
            label: this.$i18n_t('Consumers.Filter.createDialog.operators.isNotNull'),
            value: 'IS_NOT_NULL'
          }]
        }
      }, {
        field: valueField
      }]];
      var healthStateRows = currentHealthStates.map(function (state, stateIndex) {
        return {
          class: 'v-card v-sheet elevation-2 v-card__text',
          columns: [{
            rows: inputRows.map(function (inputRow) {
              var inputColumns = inputRow.map(function (input) {
                var computedField = typeof input.field === 'function' ? input.field(state) : input.field;
                return {
                  cols: input.cols,
                  sm: input.sm,
                  md: input.md,
                  lg: input.lg,
                  field: _objectSpread(_objectSpread({}, computedField), {}, {
                    key: "".concat(healthBaseKey, "[").concat(stateIndex, "].").concat(computedField.key)
                  })
                };
              });
              return {
                columns: inputColumns
              };
            })
          }, {
            class: 'flex-grow-0',
            rows: [{
              columns: [{
                field: {
                  type: 'button',
                  icon: 'fal fa-trash',
                  onClick: function onClick(updateField) {
                    var newHealthStates = currentHealthStates.filter(function (_, index) {
                      return index !== stateIndex;
                    });
                    updateField(healthBaseKey, newHealthStates);
                  }
                }
              }]
            }]
          }]
        };
      });
      var addButtonRow = {
        columns: [{
          class: 'flex-grow-0 pl-0',
          field: {
            type: 'button',
            icon: 'fal fa-plus',
            onClick: function onClick(updateField) {
              var nextUnusedMetricID = 0;

              while (currentHealthStates.some(function (m) {
                return m.identifier === "metric_".concat(nextUnusedMetricID);
              })) {
                nextUnusedMetricID++;
              }

              var emptyState = {
                type: 'warning',
                // TODO: how to handle this?
                jsTransformer: '',
                wizard: true,
                operator: 'EQUALS',
                identifier: "metric_".concat(nextUnusedMetricID),
                wiredState: '_raw',
                category: '',
                description: '',
                value: ''
              };
              updateField("".concat(healthBaseKey), [].concat(_toConsumableArray(currentHealthStates), [emptyState]));
            }
          }
        }]
      };
      var healthStateRowsWithSpacers = [];
      healthStateRows.forEach(function (row, index) {
        healthStateRowsWithSpacers.push({
          subtitle: currentHealthStates[index].identifier
        });
        healthStateRowsWithSpacers.push(row);

        if (index >= healthStateRows.length - 1) {
          return;
        }

        healthStateRowsWithSpacers.push({
          isDivider: true
        });
      });

      if (healthStateRowsWithSpacers.length === 0) {
        var emptyState = {
          columns: [{
            class: 'text-center',
            field: {
              type: 'emptystate',
              icon: 'fal fa-sensor-alert',
              title: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.healthState.emptyState.title'),
              description: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.healthState.emptyState.description'),
              button: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.healthState.emptyState.buttonCreate'),
              onClick: function onClick(updateField) {
                var nextUnusedMetricID = 0;

                while (currentHealthStates.some(function (m) {
                  return m.identifier === "metric_".concat(nextUnusedMetricID);
                })) {
                  nextUnusedMetricID++;
                }

                var emptyState = {
                  type: 'warning',
                  // TODO: how to handle this?
                  jsTransformer: '',
                  wizard: true,
                  operator: 'EQUALS',
                  identifier: "metric_".concat(nextUnusedMetricID),
                  wiredState: '_raw',
                  category: '',
                  description: '',
                  value: ''
                };
                updateField("".concat(healthBaseKey), [].concat(_toConsumableArray(currentHealthStates), [emptyState]));
              }
            }
          }]
        };
        return [emptyState];
      }

      return [].concat(healthStateRowsWithSpacers, [addButtonRow]);
    },
    healthStateExpertTabRows: function healthStateExpertTabRows(item) {
      var _this6 = this;

      var healthBaseKey = 'healthDefinition';
      var selectedStatesPreview = Object.fromEntries(get(item, "".concat(healthBaseKey, ".stateKeys"), []).map(function (stateKey) {
        return [stateKey, {
          value: 'LAST_VALUE',
          time: 'ISO_TIMESTAMP_LAST_UPDATE'
        }];
      }));
      var currentMetrics = get(item, "".concat(healthBaseKey, ".health"), []);
      var dataStates = item.stateDefinition;
      var metricsRows = currentMetrics.map(function (metric, metricIndex) {
        return {
          subtitle: metric.identifier,
          columns: [// type
          {
            cols: 12,
            sm: 12,
            md: 3,
            lg: 3,
            field: {
              label: _this6.$i18n_t('Common.type'),
              key: "".concat(healthBaseKey, ".health[").concat(metricIndex, "].type"),
              type: 'select',
              options: [// TODO: add all options
              {
                value: 'warning',
                label: _this6.$i18n_t('DigitalTwin.VirtualDevice.state.health.typeWarning')
              }, {
                value: 'error',
                label: _this6.$i18n_t('DigitalTwin.VirtualDevice.state.health.typeError')
              }]
            }
          }, // category
          {
            cols: 12,
            sm: 12,
            md: 3,
            lg: 3,
            field: {
              label: _this6.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.label'),
              key: "".concat(healthBaseKey, ".health[").concat(metricIndex, "].category"),
              type: 'select',
              options: [// TODO: add all options
              {
                label: _this6.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.value.battery'),
                value: 'battery'
              }, {
                label: _this6.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.value.connectivity'),
                value: 'connectivity'
              }, {
                label: _this6.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.value.device'),
                value: 'device'
              }]
            }
          }, // identifier
          {
            cols: 12,
            sm: 12,
            md: 5,
            lg: 5,
            isSpacer: true
          }, // trash button
          {
            cols: 12,
            sm: 12,
            md: 1,
            lg: 1,
            field: {
              type: 'button',
              icon: 'fal fa-trash',
              onClick: function onClick(updateField) {
                updateField("".concat(healthBaseKey, ".health"), currentMetrics.filter(function (_, index) {
                  return index !== metricIndex;
                }));
              }
            }
          }, {
            cols: 12,
            sm: 12,
            md: 12,
            lg: 12,
            slotName: 'healthStateExpertModeMetricCodeEditor',
            field: {
              key: "".concat(healthBaseKey, ".health[").concat(metricIndex, "].jsTransformer")
            }
          }]
        };
      });
      return [// select states
      {
        subtitle: this.$i18n_t('DigitalTwin.VirtualDevice.state.health.metricDescription'),
        columns: [{
          cols: 12,
          sm: 12,
          md: 12,
          lg: 12,
          field: {
            label: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.healthState.stateKeys'),
            key: "".concat(healthBaseKey, ".stateKeys"),
            type: 'autocomplete',
            multiple: true,
            options: (dataStates || []).filter(function (state) {
              return state.key !== '_health' && state.key !== '_parsed';
            }).map(function (s) {
              return {
                label: s.key,
                value: s.key
              };
            })
          }
        }]
      }, // quick tutorial / example
      {
        isExpansionPanel: true,
        headline: this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.quickReferenceHeader'),
        subtitle: this.$i18n_t('DigitalTwin.VirtualDevice.state.health.metricExample'),
        columns: [{
          cols: 12,
          sm: 12,
          md: 12,
          lg: 12,
          field: {
            type: 'code',
            fullWidth: true,
            content: "function (params) {\n  // get battery voltage from params\n  const batteryVoltage = params['battery_voltage'].value;\n\n  // battery voltage is below 2.5V\n  if (batteryVoltage < 2.5) {\n    return \"Battery almost empty\";\n  }\n\n  // get current time/date\n  const now = new Date();\n\n  // 24hrs * 3600s/day * 1000ms/s\n  const 24hoursInMilliseconds = 24 * 3600 * 1000;\n\n  // get the last heartbeat time from params\n  const lastHeartbeatTime = new Date(params['heartbeat'].time);\n\n  // has not sent a heartbeat within 24 hours\n  if ((now - lastHeartbeatTime) > 24hoursInMilliseconds) {\n    return \"Device seems offline\";\n  }\n\n  return null;\n}"
          }
        }]
      }, // params preview
      {
        columns: [{
          cols: 12,
          sm: 12,
          md: 12,
          lg: 12,
          field: {
            type: 'code',
            fullWidth: true,
            content: "params = ".concat(JSON.stringify(selectedStatesPreview, null, 4), ";")
          }
        }]
      }].concat(_toConsumableArray(metricsRows.map(function (row, rowIndex) {
        return metricsRows.length > 1 && rowIndex !== metricsRows.length - 1 ? [row, {
          isDivider: true
        }] : [row];
      }).flat()), [// add another metric button
      {
        columns: [{
          cols: 12,
          sm: 12,
          md: 12,
          lg: 8,
          field: {
            type: 'button',
            icon: 'fal fa-plus',
            onClick: function onClick(updateField) {
              var nextUnusedMetricID = 0;

              while (currentMetrics.some(function (m) {
                return m.identifier === "metric_".concat(nextUnusedMetricID);
              })) {
                nextUnusedMetricID++;
              }

              updateField("".concat(healthBaseKey, ".health"), [].concat(_toConsumableArray(currentMetrics), [{
                identifier: "metric_".concat(nextUnusedMetricID),
                wizard: false
              }]));
            }
          }
        }]
      }]);
    }
  }
};